var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload-simple_3_",
    "data-name": "upload-simple (3)",
    transform: "translate(0.354)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7043",
    "data-name": "Rectangle 7043",
    width: 18,
    height: 18,
    transform: "translate(-0.354)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64988",
    "data-name": "Path 64988",
    d: "M86,42.968,88.968,40l2.968,2.968",
    transform: "translate(-79.923 -37.174)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_198",
    "data-name": "Line 198",
    y1: 8,
    transform: "translate(9.646 3)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64989",
    "data-name": "Path 64989",
    d: "M52.436,152v3.957a.565.565,0,0,1-.565.565H40.565a.565.565,0,0,1-.565-.565V152",
    transform: "translate(-37.174 -141.26)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.ce80f2c9651d6853db7ade929372e4ce.svg";
export { ForwardRef as ReactComponent };